<template>
  <section class="l-section">
<!--     <div class="l-section__tabs" v-if="$slots.tabs">
      <slot name="tabs" />
    </div> -->
    <div v-if="$slots.panel"
        :class="['l-section__panel', $attrs.panel === 'flex' ? 'flex --spread --middle --wrap --pad' : '']">
      <slot name="panel" />
    </div>
    <article class="l-section__content" v-if="$slots.content">
      <slot name="content" />
    </article>
    <slot />
  </section>
</template>

<style>
.l-section {
  background: var(--bg);
  width: 100%;
  padding: var(--page-pad) var(--page-pad) calc(2*var(--page-pad)) 0;
/*  max-width: 1200px;*/
/*  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);*/
  border-radius: 2px;

  margin-bottom: var(--main-pad);
  /* &:last-child { margin-bottom: 0 } */

  &__content {
    padding: var(--page-pad) 0 var(--page-pad) var(--page-pad);
    position: relative;
    /*overflow-x: hidden;*/

    > .--vert-pad-inset {
      width: calc(100% + (var(--page-pad) * 2));
      margin-left: calc(var(--page-pad) * -1);
      padding-left: var(--page-pad);
      padding-right: var(--page-pad);
    }

    hr {
      margin: 24px 0;
      background: var(--black-10);
      height: 1px;
    }

    header {
      margin-left: 0;
      padding: 6px 0;
      /*float: left;*/
      font: 600 24px Montserrat;
      display: inline-block;
      /*float: left;*/
    }

    h2 {
      font-size: 24px;
      margin-bottom: 20px;
    }

    h3 {
      font-size: 18px;
      font-weight: 600;
      font-family: Montserrat;
      margin-bottom: 20px;

      span {
        font-size: 13px;
        font-weight: 300;
        color: var(--black-50);
        margin-left: 8px;
      }
    }
  }

  &__panel {
    /*margin: calc(-1*(var(--page-pad)));*/
    /*margin-bottom: var(--page-pad);*/
    border-bottom: 1px solid #f3f3f4;
    padding: 16px 0 16px 16px;
    white-space: nowrap;
    min-height: 64px;

    &.flex {
      position: relative;
      z-index: 11;
      padding-bottom: 0;

      .btn--act { z-index: -1 }
    }

    &.--pad { padding: 16px 0 16px 16px }

    &

    > * {
      vertical-align: top;  
    }
    /*display: flex;
    align-items: center;

    > * {
      margin-left: auto;

      &:last-child {
        margin-right: 0;
      }
    }*/
    /*min-height: 62px;*/

    header {
      margin-left: 0;
      /*padding: 6px 0;*/
      float: left;
      font: 700 32px/32px Montserrat;
      display: inline-block;
      /*padding-right: 24px;*/
    }

    @media (max-width: 800px) {
      .btn--act { /* squashing */
        min-width: initial;
        span { display: none; }
        i { margin-right: 0; }
      }
      
      /*> * { order: 10 }

      header { order: 1 }
      .flex__space { order: 2 }
      .btn--act { order: 3; flex-grow: 0 }*/

    }

    .SearchInput { width: 12em; }
    .DatePickerRange { height: 32px; }
  }
}
</style>